import { twMerge } from 'tailwind-merge';
import { UI } from '@/Components/UI';
import { useTranslation } from 'react-i18next';

type DifficultyProps = {
    difficulty: number;
}

export const Difficulty = ({ difficulty }: DifficultyProps) => {
    const { t } = useTranslation(['recipes']);

    return (
        <p aria-label={t(`difficulty.${difficulty}`)}>
            {Array(5)
                .fill(1)
                .map((_, index) => (
                    <UI.Icon
                        key={index}
                        name={'restaurant_menu'}
                        className={twMerge(index > difficulty && 'opacity-30')}
                    />
                ))}
        </p>
    );
};
